import angular from "angular";
import StudentPastDrivesController from "./student-past-drives.controller";
import template from "./student-past-drives.html";
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.student.archive", {
    url: "/past-drives",
    template: template,
    controller: StudentPastDrivesController,
    controllerAs: "vm",
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.parent,
        USER_ROLES.owner,
        USER_ROLES.student,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("student.drives.archive", [])
  .config(config)
  .controller("StudentPastDrivesController", StudentPastDrivesController);
